// Spec 078 — a alternância 2D/3D vista pela tela da linha: preferência (URL + lembrança),
// detecção de WebGL (aviso único quando força 2D) e a guarda de saída do modo de edição
// (FR-013: colocação não salva pede confirmação). Sem three.js — fica fora do chunk.
import * as React from "react";
import { Notify, toast } from "@/components/ui/notify";
import { selectDirty, useSceneDraft } from "../SceneEditMode/useSceneDraft";
import { useSceneViewPreference } from "./useSceneViewPreference";
import { useWebGLSupport } from "./useWebGLSupport";
import type { LineView } from "@/types/scene.types";

export interface SceneViewSwitch {
  view: LineView;
  webgl: boolean;
  changeView: (next: LineView) => void;
}

export function useSceneViewSwitch(lineId: string, sceneMounted: boolean): SceneViewSwitch {
  const webgl = useWebGLSupport();
  const { view, setView, forced2d } = useSceneViewPreference(lineId, webgl);
  const sceneDirty = useSceneDraft(selectDirty);
  const resetSceneDraft = useSceneDraft((s) => s.reset);

  React.useEffect(() => {
    if (forced2d) toast.info("Este navegador não tem aceleração 3D; mostrando o fluxo 2D.");
  }, [forced2d]);

  const changeView = React.useCallback(
    (next: LineView) => {
      void (async () => {
        if (next === "2d" && sceneMounted && sceneDirty) {
          const ok = await Notify.confirm({
            variant: "warning",
            title: "Descartar a colocação não salva?",
            description:
              "Você moveu máquinas na cena e ainda não salvou. Ao voltar para o 2D essas alterações serão perdidas.",
            confirmLabel: "Descartar e voltar ao 2D",
            cancelLabel: "Continuar editando",
          });
          if (!ok) return;
          resetSceneDraft();
        }
        setView(next);
      })();
    },
    [sceneMounted, sceneDirty, resetSceneDraft, setView]
  );

  return { view, webgl, changeView };
}
